import {
  ApplyCouponApplicationErrors,
  ChangeStartDateApplicationErrors,
  CreateGuestOnlineOrderApplicationErrors,
  CreateOnlineOrderApplicationErrors,
  GetGuestOnlineOrderPreviewApplicationErrors,
  GetOnlineOrderPreviewApplicationErrors,
  GetPricePreviewApplicationErrors,
  SetSubmissionApplicationErrors,
} from '@wix/ambassador-pricing-plans-v2-order/types';
import { ErrorCodesMapRequiredApplicationError, ErrorCodesMapRequiredValidationError } from '@wix/error-handler';
import { ControllerFlowAPI } from '@wix/yoshi-flow-editor';
import { ErrorCodesMapWrapper } from './types';

type PricingPlansV2OrderApplicationErrors =
  | GetOnlineOrderPreviewApplicationErrors
  | CreateOnlineOrderApplicationErrors
  | ChangeStartDateApplicationErrors
  | GetPricePreviewApplicationErrors
  | ApplyCouponApplicationErrors
  | CreateGuestOnlineOrderApplicationErrors
  | GetGuestOnlineOrderPreviewApplicationErrors
  | SetSubmissionApplicationErrors;

export type PricingPlansV2OrderErrorCodesMap = ErrorCodesMapWrapper<
  ErrorCodesMapRequiredApplicationError<NonNullable<PricingPlansV2OrderApplicationErrors>> &
    ErrorCodesMapRequiredValidationError<{}>
>;

export const getPricingPlansV2OrderErrorCodesMap = (
  t: ControllerFlowAPI['translations']['t'],
): PricingPlansV2OrderErrorCodesMap => ({
  errorCodesMap: {
    applicationError: {
      PRICING_PLANS_NOT_INSTALLED: false,
      ERROR_COUPON_IS_DISABLED: () => ({
        message: t('payment.coupon-error.coupon-is-disabled'),
      }),
      ERROR_COUPON_USAGE_EXCEEDED: () => ({
        message: t('payment.coupon-error.coupon-usage-exceeded'),
      }),
      ERROR_COUPON_LIMIT_PER_CUSTOMER_EXCEEDED: () => ({
        message: t('payment.coupon-error.coupon-limit-per-customer-exceeded'),
      }),
      ERROR_COUPON_IS_NOT_ACTIVE_YET: () => ({
        message: t('payment.coupon-error.coupon-is-not-active-yet'),
      }),
      ERROR_COUPON_HAS_EXPIRED: () => ({
        message: t('payment.coupon-error.coupon-has-expired'),
      }),
      ERROR_COUPON_DOES_NOT_EXIST: () => ({
        message: t('payment.coupon-error.coupon-does-not-exists'),
      }),
      ERROR_COUPON_NOT_APPLICABLE_FOR_PLAN: () => ({
        message: t('payment.coupon-error.coupon-not-applicable-for-plan'),
      }),
      ERROR_INVALID_SUBTOTAL: () => ({ message: t('payment.coupon-error.invalid-subtotal') }),
      undefined_not_allowed: () => ({ message: t('pricing-plans-v2-order.application-error.undefined-not-allowed') }),
      MEMBER_REQUIRED: () => ({ message: t('pricing-plans-v2-order.application-error.member-required') }),
      archived_plan: () => ({ message: t('pricing-plans-v2-order.application-error.archived-plan') }),
      member_not_found: () => ({ message: t('pricing-plans-v2-order.application-error.member-not-found') }),
      purchases_limit_reached: () => ({
        message: t('pricing-plans-v2-order.application-error.purchases-limit-reached'),
      }),
      buyer_can_not_pick_future_start_date: () => ({
        message: t('pricing-plans-v2-order.application-error.buyer-can-not-pick-future-start-date'),
      }),
      invalid_start_date: () => ({ message: t('pricing-plans-v2-order.application-error.invalid-start-date') }),
      accept_payment_feature_missing: () => ({
        message: t('pricing-plans-v2-order.application-error.accept-payment-feature-missing'),
      }),
      meta_site_id_missing: () => ({ message: t('pricing-plans-v2-order.application-error.meta-site-id-missing') }),
      INVALID_ORDER_OWNER: () => ({ message: t('pricing-plans-v2-order.application-error.invalid-order-owner') }),
      invalid_order_status: () => ({ message: t('pricing-plans-v2-order.application-error.invalid-order-status') }),
      invalid_order_state: () => ({ message: t('pricing-plans-v2-order.application-error.invalid-order-state') }),
      ERROR_COUPON_ALREADY_APPLIED: () => ({
        message: t('payment.coupon-error.coupon-already-applied'),
      }),
      MISSING_BUSINESS_ADDRESS_COUNTRY: false,
      MISSING_BUSINESS_ADDRESS_SUBDIVISION: false,
      MISSING_BUSINESS_ADDRESS_STATE: false,
    },
    validationError: {},
  },
});
